/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import CreateUserQuery from '../model/CreateUserQuery';
import Error from '../model/Error';
import ReportOwner from '../model/ReportOwner';
import UpdateUserQuery from '../model/UpdateUserQuery';
import User from '../model/User';
import UserToggleActiveQuery from '../model/UserToggleActiveQuery';

/**
* Users service.
* @module api/UsersApi
* @version 0.0.1
*/
export default class UsersApi {

    /**
    * Constructs a new UsersApi. 
    * @alias module:api/UsersApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createUser operation.
     * @callback module:api/UsersApi~createUserCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a new user in the database
     * @param {module:model/CreateUserQuery} createUserQuery 
     * @param {module:api/UsersApi~createUserCallback} callback The callback function, accepting three arguments: error, data, response
     */
    createUser(createUserQuery, callback) {
      let postBody = createUserQuery;
      // verify the required parameter 'createUserQuery' is set
      if (createUserQuery === undefined || createUserQuery === null) {
        throw new Error("Missing the required parameter 'createUserQuery' when calling createUser");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/users/create', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getReportOwners operation.
     * @callback module:api/UsersApi~getReportOwnersCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ReportOwner>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Active users that can be chosen as the new owner of reports
     * @param {module:api/UsersApi~getReportOwnersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ReportOwner>}
     */
    getReportOwners(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [ReportOwner];
      return this.apiClient.callApi(
        '/users/report-owners', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getUsers operation.
     * @callback module:api/UsersApi~getUsersCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/User>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/UsersApi~getUsersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/User>}
     */
    getUsers(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [User];
      return this.apiClient.callApi(
        '/users/data', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the toggleUserActive operation.
     * @callback module:api/UsersApi~toggleUserActiveCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Toggle the active state of a user
     * @param {module:model/UserToggleActiveQuery} userToggleActiveQuery 
     * @param {module:api/UsersApi~toggleUserActiveCallback} callback The callback function, accepting three arguments: error, data, response
     */
    toggleUserActive(userToggleActiveQuery, callback) {
      let postBody = userToggleActiveQuery;
      // verify the required parameter 'userToggleActiveQuery' is set
      if (userToggleActiveQuery === undefined || userToggleActiveQuery === null) {
        throw new Error("Missing the required parameter 'userToggleActiveQuery' when calling toggleUserActive");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/users/active', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateUser operation.
     * @callback module:api/UsersApi~updateUserCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Edit a users information
     * @param {module:model/UpdateUserQuery} updateUserQuery 
     * @param {module:api/UsersApi~updateUserCallback} callback The callback function, accepting three arguments: error, data, response
     */
    updateUser(updateUserQuery, callback) {
      let postBody = updateUserQuery;
      // verify the required parameter 'updateUserQuery' is set
      if (updateUserQuery === undefined || updateUserQuery === null) {
        throw new Error("Missing the required parameter 'updateUserQuery' when calling updateUser");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/users/edit', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
